<p-dropdown
    [(ngModel)]="iconModel"
    [options]="options"
    [filter]="true"
    filterBy="label"
    [virtualScroll]="true"
    itemSize="37"
    [autoDisplayFirst]="false"
    [showClear]="true"
    styleClass="icon-dropdown"
    appendTo="body"
    placeholder="Select icon"
    (onChange)="onIconChange($event)"
    rte="V">
    <!-- Custom template for selected item -->
    <ng-template let-item pTemplate="selectedItem">
        <span
            [ngClass]="{ 'material-icons': iconSource === iconSources.Material, 'mi': iconSource === iconSources.MiPro }"
            rte="X">
            {{ item.value }}
        </span>
        <span class="icon-label" rte="Y">{{ item.label }}</span>
    </ng-template>

    <!-- Custom template for list items -->
    <ng-template let-item pTemplate="item">
        <span
            [ngClass]="{ 'material-icons': iconSource === iconSources.Material, 'mi': iconSource === iconSources.MiPro }"
            [title]="item.value"
            rte="10">
            {{ item.value }}
        </span>
        <span class="icon-label" rte="11">{{ item.label }}</span>
    </ng-template>
</p-dropdown>
